import {
  Box,
  Button,
  Container,
  Field,
  Flex,
  Input,
  Stack,
  InputGroup,
  Center,
} from '@chakra-ui/react'
import { useState } from 'react'
import { LuLock, LuMail, LuUserRound } from 'react-icons/lu'
import ToggleColorMode from '@components/ToggleColorMode'
import Logo from '@components/Logo'
import AuthImagePlaceholder from '@components/AuthImagePlaceholder'
import ErrorLabel from '@components/ErrorLabel'
import PasswordInput from '@components/PasswordInput'
import PasswordValidator from '@components/PasswordValidator'

import useForm from './useForm'

const Registration = () => {
  const [password, setPassword] = useState('');

  const { onSubmit, loading, errors } = useForm();

  return (
    <Flex height="100vh" flex="1">
      <Box position="absolute" top="4" left="4">
        <ToggleColorMode />
      </Box>
      <Center flex="1.5" py={{ base: '24', md: '32' }}>
        <Container maxW="md">
          <Stack gap="8">
            <Flex justifyContent="center">
              <Logo />
            </Flex>

            <form onSubmit={onSubmit}>
              <Stack gap="5">
                <Field.Root invalid={!!errors?.name}>
                  <Field.Label>Nome</Field.Label>
                  <InputGroup startElement={<LuUserRound />} width="full" gap={0}>
                    <Input name="name" placeholder="Ex: Antônia Raelle" minLength={3} variant="subtle" required />
                  </InputGroup>
                  {errors?.name?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>
                <Field.Root invalid={!!errors?.email}>
                  <Field.Label>E-mail</Field.Label>
                  <InputGroup startElement={<LuMail />} width="full" gap={0}>
                    <Input name="email" type="email" placeholder="exemplo@email.com" variant="subtle" required />
                  </InputGroup>
                  {errors?.email?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>
                <Field.Root invalid={!!errors?.password}>
                  <Field.Label>Senha</Field.Label>
                  <InputGroup startElement={<LuLock />} width="full" gap={0}>
                    <PasswordInput
                      name="password"
                      placeholder="••••••••"
                      minLength={8}
                      variant="subtle"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </InputGroup>
                  {errors?.password?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>

                {password && (
                  <PasswordValidator password={password} />
                )}

                <Field.Root invalid={!!errors?.confirmPassword}>
                  <Field.Label>Confirmar senha</Field.Label>
                  <InputGroup startElement={<LuLock />} width="full" gap={0}>
                    <PasswordInput name="confirmPassword" placeholder="••••••••" minLength={8} variant="subtle" required />
                  </InputGroup>
                  {errors?.confirmPassword?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>

                {errors?.general && (
                  <Flex direction="column" my={4}>
                    {errors.general.map((error, index) => (
                      <ErrorLabel key={index} text={error} />
                    ))}
                  </Flex>
                )}
                <Button
                  colorPalette="argos"
                  loading={loading}
                  type="submit"
                >
                  Cadastrar
                </Button>
              </Stack>
            </form>

          </Stack>
        </Container>
      </Center>
      <Box flex="1" hideBelow="lg">
        <AuthImagePlaceholder />
      </Box>
    </Flex>
  );
};

export default Registration;
